/* Sensory Stall: make the Kaching Cart "You're saving" line match the bundle bar (2026-09-13).
   Kaching's discounts amount already counts the bundle discount and the free gifts (100% off lines).
   The product page's Kaching-tweaks script also adds the value of free shipping (setting
   shipping_value, default 6.99) on tiers that include it, so the bar reads e.g. "You save $71.96"
   for the 2 Pack. This mirrors that: + SHIPPING_VALUE once when the cart holds a 2 or 3 Pack,
   and drops the leading minus sign. Display only; totals are untouched. */
(function () {
  var SHIPPING_VALUE = 6.99; /* keep equal to the Kaching bundle tweaks "Value of free shipping" setting */
  var FREE_SHIP_TIERS = /\b(2|3)\s*pack\b/i;
  var ATTR = 'data-ss-src';

  function money(text) {
    var m = String(text || '').replace(/[⁨⁩]/g, '').match(/[0-9][0-9,]*(?:[.][0-9]+)?/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : NaN;
  }
  function fmt(n, like) {
    var s = n.toFixed(2);
    var cur = (String(like || '').match(/[^\s\d.,\-⁨⁩]+/) || ['$'])[0];
    return cur.replace(/-/g, '') + s;
  }
  function hasFreeShipTier(cart) {
    var titles = cart.querySelectorAll('.kaching-cart-item--bundle .kaching-cart-item__title');
    for (var i = 0; i < titles.length; i++) { if (FREE_SHIP_TIERS.test(titles[i].textContent)) return true; }
    return false;
  }
  function apply() {
    var cart = document.querySelector('kaching-cart');
    if (!cart) return;
    var el = cart.querySelector('.kaching-cart__cart-discounts-amount');
    if (!el) return;
    var raw = el.textContent;
    if (el.getAttribute(ATTR) === raw) return; /* already rewritten from this source text */
    var base = money(raw);
    if (!(base >= 0)) return;
    var total = base + (hasFreeShipTier(cart) ? SHIPPING_VALUE : 0);
    var out = fmt(total, raw);
    el.textContent = out;
    el.setAttribute(ATTR, out);
  }
  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(function () { scheduled = false; apply(); }); }
  function start() {
    apply();
    var mo = new MutationObserver(schedule);
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
